// Import of the module

import { parseDate } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import {
  allocationTypeOptions,
  rebalancingTypeOptions,
  statusOptions,
} from "./filter";

// Type of the fields in the table

export type Version = {
  id: number;
  rebalancing_type: number | null;
  allocation_type: number | null;
  status: number | null;
  start_date: string | null;
  created_at: string;
};

// Helper function to get label from options by value
const getLabelByValue = (
  options: Array<{ value: string; label: string }>,
  value: number | null,
): string => {
  if (value === null) return "-";
  const option = options.find((opt) => parseInt(opt.value) === value);
  return option ? option.label : value.toString();
};

// Definition of the columns

export const versions_columns: ColumnDef<Version>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "rebalancing_type",
    header: "Rebalancing Type",
    cell: ({ row }) => {
      const value = row.getValue("rebalancing_type") as number | null;
      return getLabelByValue(rebalancingTypeOptions, value);
    },
  },
  {
    accessorKey: "allocation_type",
    header: "Allocation Type",
    cell: ({ row }) => {
      const value = row.getValue("allocation_type") as number | null;
      return getLabelByValue(allocationTypeOptions, value);
    },
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const value = row.getValue("status") as number | null;
      return getLabelByValue(statusOptions, value);
    },
  },
  {
    accessorKey: "start_date",
    header: "Start Date",
    cell: ({ row }) => {
      const value = row.getValue("start_date") as string | null;
      return value ? parseDate(value) : "";
    },
  },
  {
    accessorKey: "created_at",
    header: "Created At",
    cell: ({ row }) => {
      const value = row.getValue("created_at") as string;
      return parseDate(value);
    },
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
